<!-- <app-responsive-toolbar></app-responsive-toolbar> -->
<!-- <app-headline></app-headline>  -->
  <app-navigation></app-navigation> 
 

<mat-drawer-container class="example-container" autosize>
  <!-- <mat-drawer [opened]="isDrawerOpened" class="example-sidenav" mode="side">
 
 
    <app-left-menu></app-left-menu>
  </mat-drawer> -->

  <div class="example-sidenav-content">
    <!-- <span *ngIf="!isMobile" >
    <button type="button" mat-button (click)="toggle()">
      Toggle sidenav
    </button></span> -->
    <router-outlet></router-outlet>  
  </div>

</mat-drawer-container>
<app-footer ></app-footer>
